import React, { Component } from "react";
import styled from "styled-components";

const KeithRatnerLogoContainer = styled.div`
  position: absolute;
  top: 1.5em;
  right: 1.5em;
`;

export class KeithRatnerLogo extends Component {
  componentDidMount() {
    setTimeout(() => {
      document.getElementById("krlogo__fname").classList.remove("init");
    }, this.props.delayF);
    setTimeout(() => {
      document.getElementById("krlogo__lname").classList.remove("init");
    }, this.props.delayL);
  }
  render() {
    return (
      <KeithRatnerLogoContainer id={this.props.id}>
        <svg
          version="1.1"
          id={this.props.svgid}
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          width="314.931px"
          height="105.662px"
          viewBox="0 0 314.931 105.662"
          enableBackground="new 0 0 314.931 105.662"
          xmlSpace="preserve"
        >
          <g className="init" id="krlogo__fname">
            <path
              fill="none"
              stroke="#FFF200"
              strokeMiterlimit="10"
              d="M0.5,0.818h15.926v19.477L33.108,0.818h21.181L35.481,20.272
		l19.651,32.085H35.521L24.654,31.162l-8.228,8.619v12.577H0.5V0.818z"
            />
            <path
              fill="none"
              stroke="#FFF200"
              strokeMiterlimit="10"
              d="M98.445,37.24H69.758c0.258,2.297,0.879,4.008,1.863,5.133
		c1.383,1.617,3.187,2.426,5.414,2.426c1.406,0,2.742-0.352,4.008-1.055c0.773-0.445,1.605-1.23,2.496-2.355l14.098,1.301
		c-2.157,3.75-4.758,6.439-7.805,8.068c-3.047,1.629-7.418,2.443-13.113,2.443c-4.945,0-8.836-0.698-11.672-2.092
		c-2.836-1.394-5.186-3.609-7.049-6.645c-1.863-3.035-2.795-6.604-2.795-10.705c0-5.836,1.869-10.559,5.607-14.168
		c3.738-3.609,8.9-5.414,15.486-5.414c5.344,0,9.562,0.809,12.656,2.426s5.449,3.961,7.066,7.031
		c1.617,3.071,2.426,7.066,2.426,11.988V37.24z M83.891,30.384c-0.281-2.765-1.025-4.746-2.232-5.941
		c-1.208-1.195-2.795-1.793-4.764-1.793c-2.273,0-4.09,0.902-5.449,2.707c-0.867,1.125-1.418,2.801-1.652,5.027H83.891z"
            />
            <path
              fill="none"
              stroke="#FFF200"
              strokeMiterlimit="10"
              d="M105.547,0.818h14.309v9.738h-14.309V0.818z M105.547,15.021h14.309
		v37.336h-14.309V15.021z"
            />
            <path
              fill="none"
              stroke="#FFF200"
              strokeMiterlimit="10"
              d="M146.258,0.818v14.203h7.875v10.477h-7.875v13.228
		c0,1.591,0.152,2.644,0.457,3.157c0.469,0.796,1.289,1.193,2.461,1.193c1.055,0,2.531-0.304,4.43-0.913l1.055,9.877
		c-3.539,0.773-6.844,1.16-9.914,1.16c-3.563,0-6.188-0.457-7.875-1.37c-1.688-0.913-2.936-2.299-3.744-4.16
		c-0.809-1.861-1.213-4.875-1.213-9.042V25.498h-5.273V15.021h5.273V8.166L146.258,0.818z"
            />
            <path
              fill="none"
              stroke="#FFF200"
              strokeMiterlimit="10"
              d="M160.953,0.818h14.309v18.984c1.945-2.016,3.879-3.457,5.801-4.324
		c1.921-0.867,4.195-1.301,6.82-1.301c3.89,0,6.955,1.184,9.193,3.551c2.238,2.368,3.357,6,3.357,10.898v23.73h-14.379V31.826
		c0-2.343-0.434-4.002-1.301-4.975c-0.867-0.972-2.086-1.459-3.656-1.459c-1.735,0-3.141,0.656-4.219,1.969
		c-1.078,1.313-1.617,3.668-1.617,7.066v17.93h-14.309V0.818z"
            />
          </g>
          <g className="init" id="krlogo__lname">
            <path
              fill="none"
              stroke="#FFF200"
              strokeMiterlimit="10"
              d="M55.115,104.318V52.779h26.543c4.922,0,8.684,0.422,11.285,1.266
		s4.699,2.408,6.293,4.693s2.391,5.068,2.391,8.35c0,2.86-0.609,5.326-1.829,7.4s-2.896,3.756-5.03,5.045
		c-1.36,0.821-3.225,1.5-5.593,2.039c1.896,0.634,3.278,1.267,4.146,1.9c0.586,0.422,1.435,1.326,2.547,2.71s1.856,2.452,2.23,3.202
		l7.713,14.934H87.815l-8.513-15.75c-1.078-2.039-2.039-3.363-2.883-3.973c-1.148-0.796-2.449-1.195-3.902-1.195h-1.406v20.918
		H55.115z M71.111,73.662h6.715c0.727,0,2.133-0.234,4.219-0.703c1.055-0.211,1.916-0.75,2.584-1.617
		c0.668-0.867,1.002-1.863,1.002-2.988c0-1.664-0.527-2.941-1.582-3.832c-1.055-0.891-3.035-1.336-5.941-1.336h-6.996V73.662z"
            />
            <path
              fill="none"
              stroke="#FFF200"
              strokeMiterlimit="10"
              d="M123.002,79.076l-13.676-1.441c0.516-2.391,1.26-4.271,2.232-5.643
		s2.373-2.561,4.201-3.568c1.312-0.726,3.117-1.289,5.414-1.688c2.297-0.398,4.781-0.598,7.453-0.598
		c4.289,0,7.734,0.241,10.336,0.721c2.602,0.48,4.77,1.482,6.504,3.006c1.219,1.055,2.18,2.549,2.883,4.482s1.055,3.779,1.055,5.537
		v16.488c0,1.758,0.111,3.135,0.334,4.131c0.223,0.997,0.709,2.268,1.459,3.814h-13.43c-0.539-0.961-0.891-1.693-1.055-2.197
		c-0.164-0.504-0.328-1.295-0.492-2.373c-1.875,1.805-3.738,3.094-5.59,3.867c-2.531,1.031-5.473,1.547-8.824,1.547
		c-4.453,0-7.834-1.031-10.143-3.094c-2.309-2.062-3.463-4.605-3.463-7.629c0-2.835,0.832-5.168,2.496-6.996
		s4.734-3.187,9.211-4.078c5.367-1.078,8.848-1.833,10.441-2.268c1.594-0.434,3.281-1.002,5.062-1.705
		c0-1.758-0.363-2.988-1.09-3.691s-2.004-1.055-3.832-1.055c-2.344,0-4.102,0.375-5.273,1.125
		C124.303,76.357,123.564,77.459,123.002,79.076z M135.412,86.599c-1.969,0.703-4.02,1.324-6.152,1.863
		c-2.906,0.773-4.746,1.535-5.52,2.285c-0.797,0.773-1.195,1.652-1.195,2.637c0,1.125,0.393,2.045,1.178,2.76
		c0.785,0.715,1.939,1.072,3.463,1.072c1.594,0,3.076-0.387,4.447-1.16s2.344-1.717,2.918-2.83c0.574-1.113,0.861-2.561,0.861-4.342
		V86.599z"
            />
            <path
              fill="none"
              stroke="#FFF200"
              strokeMiterlimit="10"
              d="M174.014,52.779v14.203h7.875v10.477h-7.875v13.228
		c0,1.591,0.152,2.644,0.457,3.157c0.469,0.796,1.289,1.193,2.461,1.193c1.055,0,2.531-0.304,4.43-0.913l1.055,9.877
		c-3.539,0.773-6.844,1.16-9.914,1.16c-3.562,0-6.188-0.457-7.875-1.37c-1.688-0.913-2.936-2.299-3.744-4.16
		c-0.809-1.861-1.213-4.875-1.213-9.042V77.459h-5.273V66.982h5.273v-6.855L174.014,52.779z"
            />
            <path
              fill="none"
              stroke="#FFF200"
              strokeMiterlimit="10"
              d="M188.709,66.982h13.324v6.082c1.992-2.484,4.008-4.259,6.047-5.326
		c2.039-1.066,4.523-1.6,7.453-1.6c3.961,0,7.061,1.178,9.299,3.533s3.357,5.994,3.357,10.916v23.73h-14.379V83.787
		c0-2.343-0.434-4.002-1.301-4.975c-0.867-0.972-2.086-1.459-3.656-1.459c-1.734,0-3.141,0.656-4.219,1.969
		c-1.078,1.313-1.617,3.668-1.617,7.066v17.93h-14.309V66.982z"
            />
            <path
              fill="none"
              stroke="#FFF200"
              strokeMiterlimit="10"
              d="M278.182,89.201h-28.688c0.258,2.297,0.879,4.008,1.863,5.133
		c1.383,1.617,3.188,2.426,5.414,2.426c1.406,0,2.742-0.352,4.008-1.055c0.773-0.445,1.605-1.23,2.496-2.355l14.098,1.301
		c-2.156,3.75-4.758,6.439-7.805,8.068s-7.418,2.443-13.113,2.443c-4.945,0-8.836-0.698-11.672-2.092s-5.186-3.609-7.049-6.645
		c-1.863-3.035-2.795-6.604-2.795-10.705c0-5.836,1.869-10.559,5.607-14.168c3.738-3.609,8.9-5.414,15.486-5.414
		c5.344,0,9.562,0.809,12.656,2.426s5.449,3.961,7.066,7.031c1.617,3.071,2.426,7.066,2.426,11.988V89.201z M263.627,82.345
		c-0.281-2.765-1.025-4.746-2.232-5.941s-2.795-1.793-4.764-1.793c-2.273,0-4.09,0.902-5.449,2.707
		c-0.867,1.125-1.418,2.801-1.652,5.027H263.627z"
            />
            <path
              fill="none"
              stroke="#FFF200"
              strokeMiterlimit="10"
              d="M284.896,66.982h13.395v6.117c1.289-2.648,2.619-4.47,3.99-5.467
		c1.371-0.996,3.064-1.494,5.08-1.494c2.109,0,4.418,0.656,6.926,1.969l-4.43,10.195c-1.688-0.703-3.023-1.055-4.008-1.055
		c-1.875,0-3.328,0.773-4.359,2.32c-1.477,2.18-2.215,6.258-2.215,12.234v12.516h-14.379V66.982z"
            />
          </g>
        </svg>
      </KeithRatnerLogoContainer>
    );
  }
}
